module.exports = __webpack_public_path__ + "static/media/Podrick Payne.57dfb0c8.jpg";